import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Piece } from 'app/models/piece.model';
import { PhotoLieu } from 'app/models/photoLieu.model';

@Injectable({
  providedIn: 'root'
})
export class PieceService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'pieces';

  constructor(private http: HttpClient) { }

  getPieces(dossier_intervention_id: number): Observable<Piece[]> {
    return this.http.get<Piece[]>(this.API_URL + 'dossiers-interventions/' + dossier_intervention_id + '/' + this.MODEL_URL).pipe(
        catchError(err => throwError(err))
    );
  }

  getPiece(id: number): Observable<Piece>{
    return this.http.get<Piece>(this.API_URL + this.MODEL_URL + '/' + id).pipe(
        catchError(err => throwError(err))
    );
}

  store(piece: Piece): Observable<Piece> {
    return this.http.post<Piece>(this.API_URL + this.MODEL_URL, piece).pipe(
      catchError(err => throwError(err))
    );
  }

  update(piece: Piece, id: number): Observable<Piece> {
    return this.http.put<Piece>(this.API_URL + this.MODEL_URL + '/' + id, piece).pipe(
      catchError(err => throwError(err))
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }

  updatePhotosLieux(photosLieux: PhotoLieu[], id: number){
    return this.http.post<Piece>(this.API_URL + this.MODEL_URL + '/' + id + '/update-photos-lieux', photosLieux).pipe(
      catchError(err => throwError(err))
    );
  }
}
